import ApiEndpointConstants from "../constants/ApiEndpointConstants";
import api from "./API";

export const editTieZi = (param) => {
  return api.post(`${ApiEndpointConstants.ADD_TIEZI}`, param);
};
